<template>
    <div id="app" class="bg-dark" >
      <TopMenu/>
      <iframe src="/static/propertyGenerator" style="width: 100%; height: 100vh; border: none;"></iframe>
      <div style="height: 50px;"></div>
    </div>
  </template>
  
  <script>
  import 'bootstrap/dist/css/bootstrap.css'
  import 'bootstrap-vue/dist/bootstrap-vue.css'

  import TopMenu from '../components/TopMenu.vue'
  
  export default {
    name: 'App',
    components: {
        TopMenu
  },
    data() {
        return {
            filter: '',
            loading: false,
        }
    },
    async mounted() {
    },
    beforeDestroy () {
    },
  
    watch: {
    },
    computed: {  
    },
    methods: {
    }
  }
  </script>
  
  <style>
    @import '../assets/styles/global.css';
  
  
  </style>